import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Modal,
  IconButton,
  TextField,
  Chip,
  Paper,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import MessageIcon from "@mui/icons-material/Message";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";

const serviceProviders = ["CRM", "Shariah", "R&D Pre audit", "Finance", "Audit", "Client", "R&D Post audit"];

const sampleData = [
  {
    id: 1,
    rawMaterialName: "Baking soda",
    category: "Acid regulators",
    usage: "Cooking essentials",
    brandName: "Super baking soda",
    manufacturerName: "ITC",
    bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
  },
  {
    id: 2,
    rawMaterialName: "Tofu",
    category: "Dairy products",
    usage: "Ingredients",
    brandName: "Peanut chilli tofu",
    manufacturerName: "Mooz",
    bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
  },
  {
    id: 3,
    rawMaterialName: "Milk",
    category: "Dairy products",
    usage: "Raw material",
    brandName: "Amul Milk",
    manufacturerName: "ITC",
    bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
  },
  {
    id: 4,
    rawMaterialName: "Nuts",
    category: "Anticaking agents",
    usage: "Cooking essentials",
    brandName: "Super baking soda",
    manufacturerName: "ITC",
    bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
  },
];

const RawMaterialPage = () => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [message, setMessage] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleOpenMessageBox = (index) => {
    setSelectedRow(index);
    setMessage("");
  };

  const handleCloseMessageBox = () => {
    setSelectedRow(null);
    setShowSuggestions(false);
  };

  const handleMessageChange = (event) => {
    const value = event.target.value;
    setMessage(value);

    setShowSuggestions(value.slice(-1) === "@");
  };

  const handleSelectService = (service) => {
    const updatedMessage = message.replace(/@$/, `@${service} `);
    setMessage(updatedMessage);
    setShowSuggestions(false);
  };

  const handleSendMessage = () => {
    alert(`Message sent: ${message}`);
    handleCloseMessageBox();
  };

  return (
    <Box sx={{ padding: "16px" }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
        Raw Material Listing
      </Typography>

      <TableContainer sx={{ border: "1px solid #ddd", borderRadius: "8px" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFC" }}>
              <TableCell sx={{ fontWeight: "500" }}>SL No.</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Raw Material Name</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Usage</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Brand Name</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sampleData.map((material, index) => (
              <TableRow key={material.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{material.rawMaterialName}</TableCell>
                <TableCell>{material.category}</TableCell>
                <TableCell>{material.usage}</TableCell>
                <TableCell>{material.brandName}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleOpenMessageBox(index)}>
                    <MessageIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedRow !== null && (
        <Paper sx={{ mt: 2, p: 2, borderRadius: "8px" }}>
          <TextField
            fullWidth
            multiline
            value={message}
            onChange={handleMessageChange}
            placeholder="Please provide your feedback..."
          />
          {showSuggestions && (
            <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
              {serviceProviders.map((provider) => (
                <Chip
                  key={provider}
                  label={provider}
                  sx={{
                    bgcolor: provider === "CRM" ? "#E8DBFF" : provider === "Shariah" ? "#DBEEFF" : provider === "Finance" ? "#FBF3E3" : provider === "Audit" ? "#EDFCF6" : provider === "Client" ? "#F1DEB9" : "#78625B",
                    color: "black",
                    fontWeight: "600",
                    "&:hover": { bgcolor: "inherit" },
                  }}
                  onClick={() => handleSelectService(provider)}
                  clickable
                  color="primary"
                />
              ))}
            </Box>
          )}
          <Grid container justifyContent="flex-end" spacing={1} sx={{ mt: 1 }}>
            <Grid item>
              <Button variant="outlined" sx={{ color: "black", bgcolor: "white" }} onClick={handleCloseMessageBox} startIcon={<CloseIcon />}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" sx={{ color: "white", bgcolor: "black" }} onClick={handleSendMessage}>
                Send
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}

      <Grid container justifyContent="flex-end" gap={1} sx={{ mt: 2 }}>
        <CustomSecondaryButton label={"Back"} />
        <CustomSuccessButton label={"Approved"} />
      </Grid>
    </Box>
  );
};

export default RawMaterialPage;
